import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PresentationProvider } from "@/context/PresentationContext";
import { AppShell } from "@/components/AppShell";
import LoginPage from "@/pages/Login";
import Home from "@/pages/Home";
import MyWork from "@/pages/MyWork";
import NotificationsPage from "@/pages/Notifications";
import Documents from "@/pages/Documents";
import Reports from "@/pages/Reports";
import Audit from "@/pages/Audit";
import Profile from "@/pages/Profile";
import Dinacharya from "@/pages/Dinacharya";
import VivekaKartha from "@/pages/VivekaKartha";
import Cycles from "@/pages/panchatanthra/Cycles";
import PanchatanthraOverview from "@/pages/panchatanthra/Overview";
import Survey from "@/pages/Survey";
import ElementWorkspace from "@/pages/ElementWorkspace"; // eslint-disable-line no-unused-vars
import FamilyCharter from "@/pages/viveka/FamilyCharter";
import WealthAllocation from "@/pages/viveka/WealthAllocation"; // eslint-disable-line no-unused-vars
import LegacySystem from "@/pages/viveka/LegacySystem";
import CycleDetail from "@/pages/panchatanthra/CycleDetail";
import Trends from "@/pages/panchatanthra/Trends";
import Commitments from "@/pages/panchatanthra/Commitments";
import AdminTenants from "@/pages/admin/Tenants";
import AdminDinacharyaLinks from "@/pages/admin/DinacharyaLinks";
import DinacharyaScoreTrends from "@/pages/dinacharya/ScoreTrends";
import WealthOverview from "@/pages/viveka/wealth/WealthOverview";
import FamilyWealthProfile from "@/pages/viveka/wealth/FamilyWealthProfile";
import AssetRegister from "@/pages/viveka/wealth/AssetRegister";
import WealthAllocatorV2 from "@/pages/viveka/wealth/WealthAllocator";
import WealthLiquidity from "@/pages/viveka/wealth/WealthLiquidity";
import WorkbookStatements from "@/pages/viveka/wealth/WorkbookStatements"; // eslint-disable-line no-unused-vars
import WealthBridge from "@/pages/viveka/wealth/WealthBridge";
import WealthPositions from "@/pages/viveka/wealth/WealthPositions";
import AdminWealthConfiguration from "@/pages/admin/WealthConfiguration";
import AdminFpConfiguration from "@/pages/admin/FpConfiguration";
import FpOverview from "@/pages/panchatanthra/fp/FpOverview";
import FpExecutivePack from "@/pages/panchatanthra/fp/FpExecutivePack";
import FpSources from "@/pages/panchatanthra/fp/FpSources";
import FpMapping from "@/pages/panchatanthra/fp/FpMapping";
import FpReconciliation from "@/pages/panchatanthra/fp/FpReconciliation";
import FpReadiness from "@/pages/panchatanthra/fp/FpReadiness";
import FpBudgets from "@/pages/panchatanthra/fp/FpBudgets";
import FpMappingReview from "@/pages/panchatanthra/fp/FpMappingReview";
import FpOutputs from "@/pages/panchatanthra/fp/FpOutputs";
import FpWorkbooks from "@/pages/panchatanthra/fp/FpWorkbooks";
import FpTrace from "@/pages/panchatanthra/fp/FpTrace";
import FpParameters from "@/pages/panchatanthra/fp/FpParameters";
import FpLevel3 from "@/pages/panchatanthra/fp/FpLevel3";
import FpLineReview from "@/pages/panchatanthra/fp/FpLineReview";
import FpReconGrids from "@/pages/panchatanthra/fp/FpReconGrids";
import FpExplorer from "@/pages/panchatanthra/fp/FpExplorer";
import FpValidation from "@/pages/panchatanthra/fp/FpValidation";
import FpSetup from "@/pages/panchatanthra/fp/FpSetup";
import FpWizard from "@/pages/panchatanthra/fp/FpWizard";
import AdminFrameworks from "@/pages/admin/Frameworks";
import AdminOrg from "@/pages/admin/OrgHierarchy";
import AdminRoles from "@/pages/admin/Roles";
import AdminConfidentiality from "@/pages/admin/Confidentiality";
import AdminConfigurations from "@/pages/admin/Configurations";
import AdminWorkflows from "@/pages/admin/Workflows";
import AdminNotifications from "@/pages/admin/NotificationManager";
import AdminImports from "@/pages/admin/Imports";
import AdminWorkbooks from "@/pages/admin/Workbooks";
import Showcase from "@/pages/Showcase";

const Shell = () => (
  <AppShell>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/my-work" element={<MyWork />} />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/audit" element={<Audit />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/panchatanthra" element={<PanchatanthraOverview />} />
      <Route path="/survey/:framework" element={<Survey />} />
      <Route path="/frameworks/:framework/elements/:code" element={<LegacySystem />} />
      <Route path="/panchatanthra/cycles" element={<Cycles />} />
      <Route path="/panchatanthra/cycles/:cycleId" element={<CycleDetail />} />
      <Route path="/panchatanthra/trends" element={<Trends />} />
      <Route path="/panchatanthra/commitments" element={<Commitments />} />
      <Route path="/panchatanthra/financial-engine" element={<FpExecutivePack />} />
      <Route path="/panchatanthra/financial-engine/overview" element={<FpOverview />} />
      <Route path="/panchatanthra/financial-engine/sources" element={<FpSources />} />
      <Route path="/panchatanthra/financial-engine/mapping" element={<FpMapping />} />
      <Route path="/panchatanthra/financial-engine/reconciliation" element={<FpReconciliation />} />
      <Route path="/panchatanthra/financial-engine/readiness" element={<FpReadiness />} />
      <Route path="/panchatanthra/financial-engine/budgets" element={<FpBudgets />} />
      <Route path="/panchatanthra/financial-engine/review" element={<FpMappingReview />} />
      <Route path="/panchatanthra/financial-engine/line-review" element={<FpLineReview />} />
      <Route path="/panchatanthra/financial-engine/reconciliation-grids" element={<FpReconGrids />} />
      <Route path="/panchatanthra/financial-engine/outputs" element={<FpOutputs />} />
      <Route path="/panchatanthra/financial-engine/workbooks" element={<FpWorkbooks />} />
      <Route path="/panchatanthra/financial-engine/trace" element={<FpTrace />} />
      <Route path="/panchatanthra/financial-engine/parameters" element={<FpParameters />} />
      <Route path="/panchatanthra/financial-engine/level3" element={<FpLevel3 />} />
      <Route path="/panchatanthra/financial-engine/explorer" element={<FpExplorer />} />
      <Route path="/panchatanthra/financial-engine/validation" element={<FpValidation />} />
      <Route path="/panchatanthra/financial-engine/setup" element={<FpSetup />} />
      <Route path="/panchatanthra/financial-engine/new-engagement" element={<FpWizard />} />
      <Route path="/viveka-kartha" element={<VivekaKartha />} />
      <Route path="/viveka-kartha/family-charter" element={<FamilyCharter />} />
      <Route path="/viveka-kartha/wealth-allocation" element={<Navigate to="/viveka-kartha/wealth" replace />} />
      <Route path="/viveka-kartha/legacy" element={<LegacySystem />} />
      <Route path="/dinacharya" element={<Dinacharya />} />
      <Route path="/admin/tenants" element={<AdminTenants />} />
      <Route path="/admin/dinacharya-links" element={<AdminDinacharyaLinks />} />
      <Route path="/dinacharya/score-trends" element={<DinacharyaScoreTrends />} />
      <Route path="/viveka-kartha/wealth" element={<WealthOverview />} />
      <Route path="/viveka-kartha/wealth/profile" element={<FamilyWealthProfile />} />
      <Route path="/viveka-kartha/wealth/register" element={<AssetRegister />} />
      <Route path="/viveka-kartha/wealth/allocator" element={<WealthAllocatorV2 />} />
      <Route path="/viveka-kartha/wealth/liquidity" element={<WealthLiquidity />} />
      <Route path="/viveka-kartha/wealth/workbook" element={<Navigate to="/viveka-kartha/wealth" replace />} />
      <Route path="/viveka-kartha/wealth/bridge" element={<WealthBridge />} />
      <Route path="/viveka-kartha/wealth/positions" element={<WealthPositions />} />
      <Route path="/admin/wealth-configuration" element={<AdminWealthConfiguration />} />
      <Route path="/admin/fp-configuration" element={<AdminFpConfiguration />} />
      <Route path="/admin/frameworks" element={<AdminFrameworks />} />
      <Route path="/admin/org" element={<AdminOrg />} />
      <Route path="/admin/roles" element={<AdminRoles />} />
      <Route path="/admin/confidentiality" element={<AdminConfidentiality />} />
      <Route path="/admin/configurations" element={<AdminConfigurations />} />
      <Route path="/admin/workflows" element={<AdminWorkflows />} />
      <Route path="/admin/notifications" element={<AdminNotifications />} />
      <Route path="/admin/imports" element={<AdminImports />} />
      <Route path="/admin/workbooks" element={<AdminWorkbooks />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </AppShell>
);

const Gate = () => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="session-loading">
        <p className="label-caps animate-pulse">Verifying session</p>
      </div>
    );
  return user === false ? (
    <LoginPage />
  ) : (
    <Routes>
      <Route path="/showcase" element={<Showcase />} />
      <Route path="*" element={<Shell />} />
    </Routes>
  );
};

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PresentationProvider>
            <Gate />
          </PresentationProvider>
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
